import React, { useState, useCallback } from "react"
import "./newLandingSection.scss"
import { motion } from "framer-motion"
import imagePlace from "../../../images/Hero Image.webp"
// import chatIcon from "../../../images/input-icon.svg"
import chatIcon from "../../../images/Chat Homepage icon.svg"
import sendIcon from "../../../images/send-icon.svg"
import TenYearsInBusiness from "./10YearsInBusiness/TenYearsInBusiness"
import { useAppContext } from "../../../context/appContext"
import { Link } from "gatsby"

function NewLandingSection() {
  const {
    state: { showNewChatWindow },
    setHomepageMessage,
    setShowNewChatWindow,
    setSendHomepageChatMessage,
  } = useAppContext()

  const [message, setMessage] = useState("")

  const handleSendMessage = useCallback(() => {
    if (message.trim()) {
      setShowNewChatWindow(true)
      setHomepageMessage(message)
      setSendHomepageChatMessage(true)
      setMessage("")
    }
  }, [
    message,
    setHomepageMessage,
    setSendHomepageChatMessage,
    setShowNewChatWindow,
  ])

  const handleEnterPress = useCallback(
    e => {
      if (e.key === "Enter") handleSendMessage()
    },
    [handleSendMessage]
  )

  const handleChange = useCallback(e => {
    setMessage(e.target.value)
  }, [])

  return (
    <div>
      <div className="new-landing-section">
        <div className="new-landing-header-section">
          <div className="new-landing-content-header">
            <h1>
              We take your enterprise AI <br /> from{" "}
              <strong>ideation to production</strong>
            </h1>
            <h2>
              <span>@Unparalleled speed </span>
              with Services-as-a-Software
            </h2>
            <div className="landing-section-cta-wrapper">
              <h3>
                Unlock Meaningful <span>Business Outcomes With AI</span>
              </h3>
              <div
                // whileInView={{ opacity: 1, y: 0 }}
                // initial={{ opacity: 0, y: 20 }}
                // transition={{ type: "linear", delay: 0.1 }}
                className="new-buttons-wrapper"
              >
                <div className="new-button-container">
                  <Link to="/book-demo">
                    <button className="old-design blue standout">
                      Learn more
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="chat-input-container">
            <div
              className={`chat-input-wrapper ${
                showNewChatWindow ? "disabled" : ""
              }`}
              // style={{ display: "none" }}
            >
              <img
                src={chatIcon}
                alt="chat icon"
                className="chat-icon"
                title="Open Chat"
                onClick={() => setShowNewChatWindow(true)}
              />
              <input
                onChange={handleChange}
                value={message}
                onKeyDown={handleEnterPress}
                disabled={showNewChatWindow}
                placeholder="Ask me anything about techolution"
              />
              <img
                onClick={handleSendMessage}
                src={sendIcon}
                alt="send icon"
                className="send-icon"
              />
            </div>
          </div>
        </div>
        <div className="new-landing-image-section">
          <img
            src={imagePlace}
            loading="eager"
            className="image-placeholder"
            alt="AI Solutions"
          />
        </div>
      </div>
      <TenYearsInBusiness />
    </div>
  )
}

export default React.memo(NewLandingSection)
